// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/src/Jzon.bs.js";

var post = Jzon.object7((function (param) {
        return [
                param.id,
                param.title,
                param.by,
                param.time,
                param.score,
                param.descendants,
                param.url
              ];
      }), (function (param) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: param[0],
                  title: param[1],
                  by: param[2],
                  time: param[3],
                  score: param[4],
                  descendants: param[5],
                  url: param[6]
                }
              };
      }), Jzon.field("id", Jzon.$$int), Jzon.field("title", Jzon.string), Jzon.field("by", Jzon.string), Jzon.field("time", Jzon.$$float), Jzon.field("score", Jzon.$$int), Jzon.optional(Jzon.field("descendants", Jzon.$$int)), Jzon.optional(Jzon.field("url", Jzon.string)));

var postIds = Jzon.array(Jzon.$$int);

var Codecs = {
  post: post,
  postIds: postIds
};

function single_story_url(id) {
  return "https://hacker-news.firebaseio.com/v0/item/" + String(id) + ".json";
}

function fetchJson(url) {
  return fetch(url).then(function (prim) {
              return prim.json();
            });
}

var topstories_url = "https://hacker-news.firebaseio.com/v0/topstories.json";

export {
  Codecs ,
  topstories_url ,
  single_story_url ,
  fetchJson ,
  
}
/* post Not a pure module */
